import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'asArray',
  standalone: false
})
export class AsArrayPipe implements PipeTransform {
  transform<T>(value: T | T[] | null | undefined): T[] {
    return Array.isArray(value) ? (value as T[]) : [];
  }
}
